import React, { useEffect, useState } from "react";
import "../../styles/admin/institutionInfo.scss";
import InstitutionDetails from "./institutionDetails";
import Teacher from "./teacher";
import Student from "./student";
import InstitutionCourse from "./institutionCourse";
import {
  useLocation,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import Cookies from "js-cookie";

const InstitutionInfo = () => {
  const role = Cookies.get("role");
  const tabs = [
    { key: "institution", label: "Institution details" },
    { key: "teacher", label: "Admin / Teachers" },
    { key: "student", label: "Students" },
    { key: "courses", label: "Courses" },
  ];

  const { setHeaderName, setIsShowSearch, searchQuery } =
    useOutletContext() || {};
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const getValidTab = (key) =>
    tabs.find((t) => t.key === key) ? key : tabs[0].key;
  const [activeTab, setActiveTab] = useState(() => {
    const fromHistory =
      (typeof window !== "undefined" &&
        window.history &&
        window.history.state &&
        window.history.state.instTab) ||
      null;
    const initial = fromHistory || searchParams.get("tab");
    return getValidTab(initial);
  });
  const title = location?.state?.title ?? searchParams.get("title");
  const type = location?.state?.type;

  const handleTabClick = (key) => {
    const next = getValidTab(key);
    setActiveTab(next);
    if (typeof window !== "undefined") {
      const curState = window.history.state || {};
      window.history.replaceState(
        { ...curState, instTab: next },
        document.title
      );
    }
  };

  useEffect(() => {
    setHeaderName(`${title}` || "Institution");
    setIsShowSearch(false);
  }, [title]);

  useEffect(() => {
    const fromHistory =
      (typeof window !== "undefined" &&
        window.history &&
        window.history.state &&
        window.history.state.instTab) ||
      null;
    const current = fromHistory || searchParams.get("tab");
    const next = getValidTab(current);
    if (next !== activeTab) setActiveTab(next);
  }, [tabs.length]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const curState = window.history.state || {};
    if (curState.instTab !== activeTab) {
      window.history.replaceState(
        { ...curState, instTab: activeTab },
        document.title
      );
    }
    if (activeTab === "courses") {
      setIsShowSearch(true);
    } else {
      setIsShowSearch(false);
    }
  }, [activeTab]);

  useEffect(() => {
    const onPop = (e) => {
      const next = getValidTab((e.state && e.state.instTab) || null);
      setActiveTab(next);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [tabs.length]);

  return (
    <div className="institution-info-container">
      <div className="institution-tab-container">
        <div
          className="segmented-tabs"
          role="tablist"
          aria-label="Institution tabs"
        >
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={activeTab === t.key}
              className={`segmented-tab ${activeTab === t.key ? "active" : ""}`}
              onClick={() => handleTabClick(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="tab-panel" role="tabpanel" aria-live="polite">
        {activeTab === "institution" && (
          <div>
            <InstitutionDetails />
          </div>
        )}
        {activeTab === "teacher" && (
          <div>
            <Teacher />
          </div>
        )}
        {activeTab === "student" && (
          <div>
            <Student type={type} />
          </div>
        )}
        {activeTab === "courses" && (
          <div>
            <InstitutionCourse searchQuery={searchQuery} />
          </div>
        )}
      </div>
    </div>
  );
};

export default InstitutionInfo;
